export enum AnimationInGame {
    VISIBLE = 'visible',
    HIDDEN = 'hidden',
}

export enum SoundInGame {
    OFF = 'sound_off',
    ON = 'sound_on',
}

const runtimeStorage = {};

// TODO:

export class UtilsLocalStorage {
    private static ANIMATION_IN_GAME_LS = 'animation_in_game';
    private static SOUND_IN_GAME_LS = 'sound_in_game';

    public static getItem(key: string) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            return runtimeStorage[key];
        }
    }

    public static setItem(key: string, value: string) {
        try {
            window.localStorage.setItem(key, value);
        } catch (e) {
            runtimeStorage[key] = value;
        }
    }

    public static get animationInGame(): AnimationInGame | null {
        return this.getItem(this.ANIMATION_IN_GAME_LS) as AnimationInGame | null;
    }

    public static setAnimationInGame(val: AnimationInGame) {
        this.setItem(this.ANIMATION_IN_GAME_LS, val);
    }

    public static get soundInGame(): SoundInGame {
        return (this.getItem(this.SOUND_IN_GAME_LS) as SoundInGame) ?? SoundInGame.ON;
    }

    public static setSoundInGame(val: SoundInGame) {
        this.setItem(this.SOUND_IN_GAME_LS, val);
    }
}
